import React from 'react'
import './Sidebar.css'
import {
    Paper,
    Typography,
    Box
} from '@material-ui/core'
import { NavLink,Link } from 'react-router-dom'

export default function TransferSidebar() {
  return (

    <div class ="SideBar">
     <Box className="side-box">
                            <Link to="#" className="Start-link">Start</Link>
                        </Box>
                        <Box className="side-box">
                            <NavLink to="/transfer/job" 
                           
                            className="Rec-info-link"
                            >Job</NavLink>
                        </Box>
                        <Box className="side-box">
                            
                            <NavLink to="/transfer/location"

                             className="Job-info-link" 
                             >Location
                            </NavLink>
                        </Box>
                        <Box className="side-box">
                            <NavLink to="/transfer/details" className="Org-link">Details</NavLink>
                        </Box>
                        
                        <Box className="side-box">
                            <NavLink to="/transfer/att" className="Att-link">Attachments</NavLink>
                        </Box>
                        <Box className="side-box">
                            <NavLink to="/transfer/compensation" className="Comp-link">Compensation</NavLink>
                        </Box>
                        <Box className="side-box">
                            <NavLink to="/summary" className="summ-link">Summary</NavLink>
                        </Box>

    </div>
  )
}

